import styled, { css } from 'styled-components';
import { theme } from '../../styles/theme';
import { MenuItemIcon } from '../Builder/EntitySelection/node/NodeIcon';
import { optionHover, overflowingStyles } from '../../styles/shareableStyles';
import { IEntityNode } from '../Builder/EntitySelection/types';
import React, { forwardRef, HTMLAttributes } from 'react';

interface IProps extends HTMLAttributes<HTMLDivElement> {
  node: IEntityNode;
  isActive?: boolean;
}

const activeStyles = css`
  ${optionHover};
  border-left-color: currentColor;
  cursor: grab;

  > svg {
    fill: ${theme.colors.mainBlue};
  }
`;

const Container = styled.div<{ $isActive?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 4px;
  width: 100%;
  min-height: 28px;
  padding-right: 12px;
  padding-left: 4px;
  border-left: 8px solid transparent;
  color: ${theme.colors.secondary800};
  outline: none;
  font-size: 12px;
  font-weight: 500;
  ${MenuItemIcon} {
    color: ${theme.colors.mainBlue};
  }
  &:hover {
    ${activeStyles};
  }
  ${({ $isActive }) => $isActive && activeStyles};
`;

const TruncatedText = styled.div`
  user-select: none;
  ${overflowingStyles};
`;

const DictionaryStyledDragItem = forwardRef<HTMLDivElement, IProps>(
  ({ children, node, isActive, ...props }, ref) => (
    <Container {...props} ref={ref} $isActive={isActive}>
      <MenuItemIcon node={node} />
      <TruncatedText>{children}</TruncatedText>
    </Container>
  ),
);

export default DictionaryStyledDragItem;
